import { WorkflowsComparison } from 'modules/workflows/lib/types'

export const EMPTY_SELECTOR_VALUE = ''
export const EMPTY_ARRAY_SELECTOR_VALUE = '[]'

export const DEFAULT_COMPARISON: WorkflowsComparison = {
  left: { name: EMPTY_SELECTOR_VALUE, source: 'input' },
  operator: 'eq',
  right: { value: EMPTY_SELECTOR_VALUE, type: 'string' },
}
